import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../codesList/actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';
import store from '../../../store';

function* assignCode({ payload: { id, type, values, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.codes.assign_user, id, data: values });

    dispatch(listActions.getCodesRequest({ type, curr_page: getState().getCodes.curr_page, filters: getState().getCodes.filters }));

    onSuccess && onSuccess(data.result);
    yield put(actions.assignCodeDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.assignCodeFailed,
      endpoint: api.codes.assign_user.url
    });
  }
}

export const assignCodeSaga = takeEvery(types.ASSIGN_CODE_REQUEST, assignCode);